import { useCallback } from 'react';
import ButtonTab, { Props } from '../input/ButtonTab';
import StyledText from '../text/StyledText';

export default function ButtonTabDialog({ ...props }: Props) {
  // callback
  const renderItem = useCallback(
    (value: string) => (
      <StyledText
        $fontSize="sm"
        $fontWeight="inherit"
        $color="inherit"
        $textAlign="center"
      >
        {value}
      </StyledText>
    ),
    []
  );

  return (
    <ButtonTab gap="xxxs" height={40} renderItem={renderItem} {...props} />
  );
}
